module.exports = __webpack_public_path__ + "static/src/content/images/processed/1000/16_9.6ff76a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/1000/16_9.jpg
// module id = NwhI
// module chunks = 1